// ** React Imports

// ** Next Imports
import { useRouter } from 'next/router'

// ** MUI Imports
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

// ** Icon Imports
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded'
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded'

// ** Hook Imports
import useFetch from 'src/hooks/useFetch'
import useSWR from 'swr'

// ** Configs
import endPoint from 'src/configs/endpoints/rekrutmenEndPoints'

// ** Custom Components Imports

// ** Third Party Imports

interface TitikRekrutmen {
  id: string
  rekrutmen_id: string
  kode: string
  titik: string
  detail: string
  created_at: string
  updated_at: string
}

interface ResponseTitikRekrutmen {
  success: boolean
  message: string
  data: TitikRekrutmen[]
}

const TitikRekrutmen = () => {
  const router = useRouter()

  const { id } = router.query

  const { FetchWithPayload } = useFetch()

  const payload = {
    url: `${endPoint.rekrutmenTitikEndpoint}/${id}`,
    method: 'GET'
  }

  const { data, isLoading } = useSWR<ResponseTitikRekrutmen>(
    id ? [`${process.env.NEXT_PUBLIC_BASE_PATH}/api/reqHandler/`, payload] : null,
    FetchWithPayload
  )

  return !isLoading && data && data.data ? (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography
        variant='body1'
        sx={{ fontWeight: 700, color: theme => theme.myColor?.colorToggle, fontSize: '1.5rem' }}
      >
        Titik Rekrutmen
      </Typography>
      {data.data.length == 0 ? (
        <Box
          sx={{
            p: 4,
            height: 100,
            borderRadius: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: theme => theme.palette.error.light
          }}
        >
          <ReportProblemRoundedIcon color='error' sx={{ mb: 2 }} />
          <Typography variant='body1' sx={{ fontWeight: 600, textAlign: 'center' }}>
            Silahkan tambahkan titik rekrutmen!
          </Typography>
        </Box>
      ) : null}
      {data.data.map(ele => (
        <Box key={ele.id} sx={{ display: 'flex', mb: 2 }}>
          <PlaceRoundedIcon sx={{ color: theme => theme.myColor?.colorToggle }} />
          <Box sx={{ pl: 2, display: 'flex', flexDirection: 'column' }}>
            <Typography variant='body1' sx={{ fontWeight: 600, fontSize: '1rem' }}>
              {`${ele.kode} - ${ele.titik}`}
            </Typography>
            <Typography variant='caption' sx={{ fontSize: '0.875rem' }}>
              {ele.detail}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  ) : null
}

export default TitikRekrutmen
